module.exports = __webpack_public_path__ + "assets/img/lx_w_d_i_18.a3e3b3e4.jpg";